//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from './Input';

export default {
    extends: Input,

    props: {
        accept: String,
        maxFileSize: Number,
    },

    methods: {
        pickFiles() {
            this.$refs.file?.pickFiles();
        },
    },
};
